/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FocusEventHandler, useState } from 'react'
import { Form, Input } from 'antd'
import classnames from 'classnames'
import { DEFAULT_INPUT_LENGTH, LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules, Validator } from '../form.utils'
import '../form.scss'
import FloatingLabel from '../floating-lable/floating-lable'

export interface InputTextProps {
  maxLength?: number
  min?: {
    value: number
    message: string
  }
  max?: {
    value: number
    message: string
  }
  isAllowClear?: boolean
  isDisabled?: boolean
  label?: string | any
  name?: string | any
  isRequired?: boolean
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  pattern?: RegExp
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  inputContainerStyle?: string
  validateTrigger?: string | string[]
  validator?: Validator
  patternMessage?: string
  prefix?: React.ReactNode
  placeholder?: string
  value?: string | ReadonlyArray<string> | number | undefined
  onBlur?: FocusEventHandler<HTMLInputElement>
  isURL?: boolean
  isEmail?: boolean
  innerRef?: any
  initialValue?: any
}

const InputText: React.FC<InputTextProps> = (props: InputTextProps) => {
  const {
    min,
    max,
    label,
    name,
    labelAlign,
    isRequired,
    validator,
    onChange,
    className,
    pattern,
    patternMessage,
    isDisabled,
    isAllowClear,
    maxLength,
    validateTrigger,
    prefix,
    value,
    inputContainerStyle,
    isURL = false,
    isEmail = false,
    innerRef,
    onBlur,
    initialValue,
  } = props

  const [active, setActive] = useState(false)

  const onBlurLocal = () => {
    setActive(false)
  }

  const onFocus = () => {
    setActive(true)
  }

  return (
    <FloatingLabel active={active} labelText={label} name={name}>
      <Form.Item
        label={label}
        name={name}
        labelAlign={labelAlign}
        validateTrigger={validateTrigger}
        className={classnames('block', className)}
        rules={formRules(
          label,
          isRequired,
          validator,
          pattern,
          patternMessage,
          min,
          max,
          isURL,
          isEmail
        )}
        validateFirst={true}
        initialValue={initialValue}
      >
        <Input
          aria-label={label}
          className={classnames('form-item-input-width', inputContainerStyle)}
          disabled={isDisabled}
          id={name}
          onChange={onChange}
          allowClear={isAllowClear}
          maxLength={maxLength || DEFAULT_INPUT_LENGTH}
          prefix={prefix}
          // placeholder={placeholder}
          value={value}
          onBlur={(e) => {
            onBlurLocal()
            onBlur?.(e)
          }}
          onFocus={onFocus}
          type={isEmail ? 'email' : 'text'}
          ref={innerRef}
          data-testid={name}
        />
      </Form.Item>
    </FloatingLabel>
  )
}

export default InputText
